import { ReactNode, createContext, useContext, useReducer } from "react";

import { InitialContext } from "../types/state/context";
import {
  MasterArtworkNumberActionTypes,
  MasterArtworkNumberState,
} from "../states/meta-artwork/artwork-number/data.type";
import { MasterArtworkNumberReducer } from "../states/meta-artwork/artwork-number";

type Context = InitialContext<MasterArtworkNumberState, MasterArtworkNumberActionTypes>;

export const MasterArtworkNumberContext = createContext<Context>({} as Context);

export function MasterArtworkNumberProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(
    MasterArtworkNumberReducer.reducer,
    MasterArtworkNumberReducer.initialState,
  );

  return (
    <MasterArtworkNumberContext.Provider value={{ state, dispatch }}>
      {children}
    </MasterArtworkNumberContext.Provider>
  );
}

export const useMasterArtworkNumberStore = () => useContext(MasterArtworkNumberContext);
